import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { IPermissionProps } from "../../models/Login";

import { ITeamSkillMast } from "../../models/ISkillTeamManagement";
import { ITeamMast } from "../teamManagement/Table";
import { EmptyTeam, TeamData, teamData } from "../teamManagement/EmptyTeam";
import { Table } from "./Table";

export interface IModel {
    open: boolean,
    singleData: ITeamSkillMast,
    teamNameList: ITeamMast[]
}

export interface IModel2 {
    open: boolean,
    singleData: ITeamSkillMast
}

export interface IModel3 {
    open: boolean,
    singleData: teamData[],
    inTeam: teamData,
    p: number | null,
    s: number | null,
}

export const SkillMastHistory = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyTeam, open: false, teamNameList: [] } as IModel);
    const [modal2, setModal2] = useState({ singleData: TeamData, open: false } as IModel2);
    const [modal3, setModal3] = useState({ singleData: [], open: false, inTeam: {}, p: null, s: null } as IModel3);
    const [reload, setReload] = useState(false);
    const [reload2, setReload2] = useState(false);
    const [reload3, setReload3] = useState(false);
    const toast = useRef<any>(null);

    
    const hideDialog2 = () => {
        setModal2({ singleData: TeamData, open: false })
    };
    const hideDialog3 = () => {
        setModal3({ singleData: [], open: false, inTeam: TeamData, p: null, s: null })
    };

    return (
        <>

      
          <Table permissions={permissions} setModal={setModal} setModal2={setModal2} toast={toast} reload={reload} setReload={setReload}></Table>
          <Toast ref={toast} />
        </>
    );
}
